module.exports = __webpack_public_path__ + "img/info-item-2.f9cb3492.png";